import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { Observable, of } from 'rxjs';

import { BaseFactory, GridSourceEvent } from './event.factory';

export class GridBaseFactory implements BaseFactory {
    canCreate(events: GridSourceEvent[]): boolean {
        return 'optionGroups' in events[0];
    }

    create(events: GridSourceEvent[]): Observable<GridEvent[]> {
        return of(events as GridEvent[]);
    }
}
